import React, {useEffect, useState} from 'react'
import UserIcon from './UserIcon'
import TextHighlight from './frontend_components/TextHighlight';
import {CheckIcon, VisDiv, PhotosBeforeAfter} from '../components';
import { AiFillExclamationCircle } from 'react-icons/ai';
import { clientUser } from '../lib/userPermissions';
import {useStateContext} from '../context/StateContext';
import { v4 as uuidv4 } from 'uuid';
import { updateDevices, keyId, timePassedTranslated } from '../lib/utils';
import { successAlert, errorAlert } from '../lib/utils';
import {  TiThumbsUp } from 'react-icons/ti';
import { AiTwotoneDelete } from 'react-icons/ai';
import {FiEdit, FiSave} from 'react-icons/fi'
import { referenceDoc } from './gestioneDatabase/Docs';
import { MdOutlineRestore } from "react-icons/md";
import Linkify from 'linkify-react';
import { fileUrl, urlFor } from '../lib/client';
import { FaFilePdf } from "react-icons/fa";



const Comment = ({comment={}, hideIcons, editFn, hideRead, setCommentToEdit=()=>{}}) => {

 
    const [status, setStatus] = useState(comment?.status)

    const {devices, setDevices, sUser, currentDevice, customerUsers, setCurrentDevice, LDB} = useStateContext();
    
    const [seenBy, setSeenBy] = useState(!Array.isArray(comment?.seenBy) ? undefined : customerUsers?.find?.((x)=> x?._id == comment?.seenBy?._ref))
    const [archivedBy, setArchivedBy] = useState(!Array.isArray(comment?.archivedBy) ? undefined : customerUsers?.find?.((x)=> x?._id == comment?.archivedBy?._ref))
    const [seenOn, setSeenOn] = useState(comment?.seenOn)
    const [severeComment, setSevereComment] = useState(comment?.severe)
    const [likedBy, setLikedBy] = useState(!Array.isArray(comment?.likedBy) ? [] : comment?.likedBy)
    const [archivedOn, setArchivedOn] = useState(comment?.archivedOn)
    const testing = false
    const postedBy = !Array.isArray(customerUsers) ? undefined : customerUsers?.find?.((x)=> x?._id == comment?.postedBy?._ref)

    const trueString = "VISTO"

    const now = Date?.now()
    const seenByUser = {
        _ref: sUser._id,
        _type: "postedBy",
        _key: keyId()
    }
    const seenByDoc = {     
        ...comment,
            status: trueString,
            seenOn: now,
            seenBy:seenByUser
    }
    const archiveDoc = {
        ...comment,
        status: "ARCHIVIATO",
        archivedOn: now,
        archivedBy: [seenByUser]
    }
    const restoreDoc = {
        ...comment,
        status: "ATTIVO",
        archivedOn: "",
        archivedBy: []
    }

       
    const user = !Array.isArray(customerUsers) ? undefined : customerUsers?.find?.((x)=> x._id == comment?.postedBy?._ref)
    const statusTranslation = () =>{ 
        if(status=="DA FARE") return LDB("misc", "toDo")
        if(status=="NON LETTO") return LDB("misc", "unread")
        if(status=="DA LEGGERE") return LDB("misc", "toRead")
        if(status=="ARCHIVIATO") return LDB("misc", "archived")
        return LDB("misc", "seen")
    }

    const highlight = () => {
        if(status=="DA FARE") return ("red")
        if(status=="NON LETTO") return ("red")
        if(status=="DA LEGGERE") return ("red")
        if(status=="ARCHIVIATO") return ("red")
        return ("green")
    }

    const isMyLikePresent = !Array.isArray(likedBy) ? false : likedBy?.some?.((x)=>x?.postedBy?._ref == sUser?._id)

    const testClick = () =>{
        //const file = production
        const fileId = comment?.pdfFiles?.[0].file?.asset?._ref
        const projectId = process.env.NEXT_PUBLIC_PROJECT_ID
        const buildUrl = `https://cdn.sanity.io/files/${projectId}/production/${fileId}.pdf`
        console.log(
            "CommentData", comment, 
           // "pdf url", buildUrl, 
            //"url", urlFor(comment?.pdfFiles?.[0].file)
        )
    }
   
    const editComment = () => {
        setCommentToEdit(comment)
        console.log("EDIT COMMENT", comment)
    }

    const likeComment = () => {
   
        if(isMyLikePresent){
            const newArray = !Array.isArray(likedBy) ? [] : likedBy?.filter?.((x)=>x?.postedBy?._ref !== sUser?._id)
            setLikedBy(newArray)
            editFn({...comment, likedBy: newArray })
        }
        else {
            const newLike = {
                postedBy: referenceDoc(sUser?._id),
                date: Date.now(),
                logType: "like",
                _key: keyId()
            }
            setLikedBy([...likedBy, newLike])
            editFn({...comment, likedBy: [...likedBy, newLike] })
        }

    }

    const severeCommentFn = () => {
        if(hideIcons) return
        if(!clientUser(sUser)) return
        const severeCommentDoc = {
            ...comment,
            severe: !severeComment,
            severeOn: !severeComment ? now : ""
    
        }
        console.log(severeCommentDoc)
        editFn(severeCommentDoc)
        setSevereComment(!severeComment)

    }

    const onCheckIconClick = () =>{
        setStatus("VISTO")
    
        setSeenOn(now)
        setSeenBy(!Array.isArray(customerUsers) ? undefined : customerUsers?.find?.((x)=> x._id == seenByDoc?.seenBy?._ref))
        editFn(seenByDoc)

    }
    const onArchiveIconClick = () =>{
        setStatus("ARCHIVIATO")
  
        setArchivedOn(now)
        setArchivedBy(!Array.isArray(customerUsers) ? undefined : customerUsers?.find?.((x)=> x._id == archiveDoc?.archivedBy?._ref))
        editFn(archiveDoc)
    }
    const restoreComment = () => {
        setStatus("ATTIVO")
        setArchivedOn("")
        setArchivedBy([])
        editFn(restoreDoc)
    }

    const linkOptions = {
        attributes: {
            target: "_blank",
            rel: "noopener noreferrer",
        },
        format: (value, type) => {
            // truncate long URLs/text
            console.log("slqèpwslqèsl",{ value, type})
            if (type === "url" && value.length > 50) {
            return value.slice(0, 47) + "...";
            }
            return value;
        },
        };

  return (
    <div className='comment-container'>
        <UserIcon
         otherUser={postedBy && postedBy}
         bypassCurrentUser={true}
        />
        <div className='comment-text-container'>
            <div style={{display: 'flex'}}>
                <p onClick={testClick} style={{color:'#324d67',fontWeight:"bold", flex:6}}>
                    {user?.firstName} {user?.lastName}
                </p>
                
                <VisDiv rules={[!hideIcons, clientUser(sUser), status=="ARCHIVIATO", comment?.postedBy?._ref == sUser?._id || sUser?.userType == "God Mode" ||  sUser?.userType == "Admin"]} className='edit-button-container' style={{marginLeft:"15px"}}>
                    <button type='button' className='round-back-button' style={{backgroundColor:"green"}} onClick={restoreComment}>
                        <MdOutlineRestore             
                        size={20}
                        color={"white"}/>
                    </button>
                </VisDiv>
                <VisDiv rules={[!hideIcons, clientUser(sUser), status!=="ARCHIVIATO", comment?.postedBy?._ref == sUser?._id || sUser?.userType == "God Mode" ||  sUser?.userType == "Admin"]} className='edit-button-container' style={{marginLeft:"15px"}}>
                    <button type='button' className='round-back-button' style={{backgroundColor:"red"}} onClick={onArchiveIconClick}>
                        <AiTwotoneDelete             
                        size={20}
                        color={"white"}/>
                    </button>
                </VisDiv>
                <VisDiv rules={[!hideIcons, clientUser(sUser), status!=="ARCHIVIATO", comment?.postedBy?._ref == sUser?._id || sUser?.userType == "God Mode" ||  sUser?.userType == "Admin"]} className='edit-button-container' style={{marginLeft:"15px"}}>
                    <button type='button' className='round-back-button' style={{backgroundColor:"red"}} onClick={editComment}>
                        <FiEdit             
                        size={15}
                        color={"white"}/>
                    </button>
                </VisDiv>

            </div>
            <VisDiv rules={[comment?.nonConformity?.label]} style={{marginBottom: "10px"}}>
{/*                 {`Non Conformità: `} */}
                <TextHighlight highlight={"darkRed"} fontSize={"12px"}>
                    {comment?.nonConformity?.label}
                </TextHighlight>
            </VisDiv>
            <div style={{
                color:"#324d67", 
                width:"100%",
                marginTop:"15px",
                wordBreak: 'break-word', // Break long words if necessary
                overflowWrap: 'break-word',
                 }}>
                {/* {comment?.comment.toUpperCase()} */}
                <Linkify options={linkOptions}>
                    {comment?.comment}
                </Linkify>

            </div>
           
            
            <br/>
            <div style={{marginTop:"10px"}}>
            <PhotosBeforeAfter
                hideAfterPictureIcon={hideIcons}
                doc = {comment}
                saveFn = {editFn}
                />
            <VisDiv rules = {[comment?.pdfs?.length > 0]}>
            {comment?.pdfs?.map?.((item, i) =>{ 
                const handleClick = () => {
                    window.open(item?.url, "_blank")
                }
                return (
                    <div style={{display:"flex", alignItems:"center", marginTop:"10px"}} onClick={handleClick} key={item?.pdfId}>
                        <button style={{backgroundColor:"#324d67", marginLeft:"10px", marginRight:"10px", width: "30px", height: "30px"}} className='round-red-button'>
                            <FaFilePdf
                                size={17}
                                color={"white"}
                                />
                        </button>
                        <h4>{item?.title}</h4>
                    </div>    
            )}
            )}    
            </VisDiv>    
            <div style={{display:"flex", alignItems:"center", justifyContent:"flex-end"}}>
                <VisDiv rules={[false, !hideRead]}>
                    <TextHighlight highlight={highlight()} fontSize={"10px"} >
                        {statusTranslation()}
                    </TextHighlight>
                </VisDiv>
                <VisDiv rules={[status == "ARCHIVIATO", !hideRead]}>
                    <TextHighlight highlight={"red"} fontSize={"10px"} >
                        {"ARCHIVIATO"}
                    </TextHighlight>
                </VisDiv>
                <VisDiv rules={[false, seenBy, status!=="ARCHIVIATO"]}>
                    <UserIcon
                    //sPicture={seenBy?.image}
                    otherUser={seenBy && seenBy}
                    style={{marginLeft:"5px"}}
                    size={20}
                    nameInitials
                    date={seenOn}
                    />
                </VisDiv>
                <VisDiv rules={[false, status=="ARCHIVIATO"]}>
                    <UserIcon
                    //sPicture={seenBy?.image}
                    otherUser={archivedBy && archivedBy}
                    style={{marginLeft:"5px"}}
                    size={20}
                    nameInitials
                    date={archivedOn}
                    />
                </VisDiv>
                <VisDiv rules={[!hideIcons]}>
                    <TiThumbsUp style={{cursor:"pointer"}} color={isMyLikePresent ? "#324d67" : "grey"} fontSize={27} onClick={likeComment}/>
                </VisDiv>

                <VisDiv rules={[]} style={{cursor: hideIcons || clientUser(sUser) && "pointer", marginLeft:"10px"}} onClick={severeCommentFn}>
      {/*               <TextHighlight pointer={true} highlight={severeComment ? "red":"none"} fontSize={"10px"} >
                        {LDB("misc","severe")}
                    </TextHighlight>  */}
                    <AiFillExclamationCircle fontSize={27} color={severeComment ? "red":"grey"} />
                </VisDiv>



            </div>
                <VisDiv rules={[testing]} onClick={testClick}>test</VisDiv>
            </div>
            <VisDiv rules={[comment?.postedOn]} onClick={()=>console.log("comment", comment)} style={{color:"grey", fontSize:"12px"}}>
                <p>{`Postato il: ${timePassedTranslated(comment?.postedOn, true)}`}</p>
            </VisDiv>
            <VisDiv rules={[comment?.lastEditOn]} onClick={()=>console.log("comment", comment)} style={{color:"grey", fontSize:"12px"}}>
                <p>{`Ultima modifica il: ${timePassedTranslated(comment?.lastEditOn, true)}`}</p>
            </VisDiv>
            <VisDiv rules={[likedBy?.length > 0]} style={{color:"grey", fontSize:"12px"}}>
                <p>{`Visto da:`}</p>
                {likedBy?.map?.((log)=>{
                    const findUser = !Array.isArray(customerUsers) ? undefined : customerUsers?.find?.((x)=> x?._id == log?.postedBy?._ref)
                    return(
                        <div  key={log?._key}>
                            <UserIcon
                            //sPicture={seenBy?.image}
                            otherUser={findUser}
                            style={{marginLeft:"5px"}}
                            date={log?.date}
                            size={20}
                            nameInitials = {true}
                            />
                        </div>

                    )})}
            </VisDiv>
            
        </div>
        <VisDiv rules={[false, sUser.userType !=='Tecnico', status !="ARCHIVIATO", !hideRead]} style={{cursor: status!== trueString && "pointer"}}>
            <CheckIcon
            onClick={status!==trueString ? onCheckIconClick : undefined} 
            status={status}
            trueString={trueString}
            />
        </VisDiv>
       
    </div>
  )
}

export default Comment
